module.exports = __webpack_public_path__ + "static/img/bjcyds.b3c508d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/bjcyds.png
// module id = ZXC6
// module chunks = 0